import React from "react";
import { Container } from "react-bootstrap";

const First = () => {
  return (
    <>
      <section
        className="first-webDevelopment-section"
        style={{ background: "var(--white-color)" }}
      >
        <Container>
          <div className="page-title text-center">
            <h1>eCommerce (B2B, B2C) Wholesale and Retail</h1>
            <div className="sub-info">
              <p>
                Ecommerce The way businesses run has undergone a complete
                transformation because of the internet. To contact clients in
                the past, businesses had to rely on brick-and-mortar stores.
              </p>
              <p>
                Businesses can now easily reach a worldwide audience with a few
                clicks.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
